<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column is-7">
        <div class="ls-share-view--share-main"><LsShareMain /></div>
        <h2 class="ls-share-view--header">{{ variationUIComponents.header_promo_main }}</h2>
        <LsShareRow
          v-for="(name, idx) in socialPlatforms"
          :key="name"
          test-id="social_share_rows"
          :name="name"
          :is-last="idx === socialPlatforms.length - 1"
        />
        <h2 class="ls-share-view--header">{{ variationUIComponents.header_promo_secondary }}</h2>
        <LsShareRow
          v-for="(name, idx) in otherPlatforms"
          :key="name"
          test-id="other_share_rows"
          :name="name"
          :is-last="idx === otherPlatforms.length - 1"
        />
        <p class="ls-share-view--disclaimer">
          Credits given for the first time you share only, unless specified otherwise.<br />
          They may take up to 72 hours to be applied to your account.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { SHARE__CUSTOMER_REFERRAL, SHARE__PRIMARY_PLATFORM } from '@/store/types';
import { mapGetters } from 'vuex';
import LsShareMain from '@/components/LsShareMain/LsShareMain.vue';
import LsShareRow from './components/LsShareRow/LsShareRow.vue';
import _ from 'lodash';
import { lsDeviceHelpers } from 'ls-vue-common';

export default {
  name: 'ShareView',
  components: {
    LsShareMain,
    LsShareRow,
  },
  computed: {
    ...mapGetters([SHARE__CUSTOMER_REFERRAL, SHARE__PRIMARY_PLATFORM]),
    variationUIComponents() {
      return this[SHARE__CUSTOMER_REFERRAL].variation_ui_components;
    },
    primaryPlatformName() {
      return this[SHARE__PRIMARY_PLATFORM].platformName;
    },
    socialPlatforms() {
      return _.pull(['nextdoor', 'facebook', 'twitter'], this.primaryPlatformName);
    },
    otherPlatforms() {
      const platforms = ['sms', 'link', 'email'];

      if (!lsDeviceHelpers.isMobile()) {
        platforms.shift();
      }

      return _.pull(platforms, this.primaryPlatformName);
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.ls-share-view--header {
  padding: 20px 0 40px 0;
  border-top: 1px solid $primary-light;
}

.ls-share-view--share-main {
  height: 370px;
}

.ls-share-view--disclaimer {
  margin-top: 75px;
  font-size: $size-6;
  color: $gray-secondary;
  text-align: center;
}

@media (min-width: $desktop) {
  .ls-share-view--header {
    padding: 40px 0;
    text-align: center;
    border-top: none;
  }
}
.themed-app {
  .ls-share-view--header {
    border-color: $theme-color-primary-light;
  }

  .ls-share-view--disclaimer {
    font-size: $size-6;
    color: $theme-color-gray-dark;
  }
}
</style>
